import { React, PT, WithData, withRouter } from '@gasbuddy/react';
import qs from 'querystring';
import { Auth, Nav, TxTable } from '../../components';
import { Role } from '../../roles';

const PAGE_SIZE = 10;

function rangeText(page) {
  return `Transactions ${(page * PAGE_SIZE) + 1}-${(page + 1) * PAGE_SIZE}`;
}

const TableProxy = ({ data, onNext, onPrev, range, showPrevious, showAccount, showReason }) => (
  <TxTable
    showAccount={showAccount}
    showReason={showReason}
    tx={data && data.transactions}
    onNext={onNext}
    onPrev={onPrev}
    pageSize={PAGE_SIZE}
    range={range}
    showPrevious={showPrevious}
  />
);

function getPage({ search }) {
  const p = Number(qs.parse(search.substring(1)).page);
  if (Number.isSafeInteger(p) && Number(p) >= 1) {
    return p;
  }
  return 1;
}

TableProxy.propTypes = TxTable.propTypes;

export const Transactions = withRouter(({
  header, footer, location, history, url, showAccount, showReason, onData, valuesForState,
}) => {
  const txPage = getPage(location);
  return (
    <Auth forRoles={[Role.Superuser, Role.PaymentView]}>
      <Nav>
        <div>
          {header}
          <WithData
            valuesForState={valuesForState}
            onData={onData}
            url={url}
            body={{ limit: PAGE_SIZE + 1, offset: (txPage - 1) * PAGE_SIZE }}
          >
            <TableProxy
              showAccount={showAccount}
              showReason={showReason}
              onNext={() => history.push(`?page=${txPage + 1}`)}
              onPrev={() => history.push(`?page=${txPage - 1}`)}
              showPrevious={txPage > 1}
              range={rangeText(txPage - 1)}
            />
          </WithData>
          {footer}
        </div>
      </Nav>
    </Auth>
  );
});

Transactions.propTypes = {
  url: PT.string.isRequired,
  showAccount: PT.bool,
  showReason: PT.bool,
  header: PT.element,
  footer: PT.element,
  onData: PT.func,
  valuesForState: PT.func,
};

Transactions.defaultProps = {
  showAccount: false,
  showReason: false,
  header: null,
  footer: null,
  onData: null,
  valuesForState: null,
};
